export const fugitifs = {
  logo_image_url: 'fugitifs/french.png',
  logo_height: 70,

  token_url: 'fugitifs.png',
  token_hidden_tokenIds: [0],

  number_hidden: true,

  body_background_color: 'black',

  button_color: 'black',
  button_radius: 50,

  text_font: `'Nunito', sans-serif`,

  photobooth_button_color: 'white',
  photobooth_button_text_color: 'black',
}

export const fugitifs_eng = {
  ...fugitifs,
  logo_image_url: 'fugitifs/english.png',
}
